import { IFontFamily } from '@aquariuxfintech/aqx-trader-sdk-config/theme';

export const ibxSansFontFamily: IFontFamily = {
  DEFAULT_FONT_FAMILY: 'IBM Plex Sans',
  DEFAULT_ANDROID_FONT_FAMILY: 'IBMPlexSans-Regular',
  DEFAULT_ANDROID_FONT_FAMILY_ITALIC: 'IBMPlexSans-Italic',
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM: 'IBMPlexSans-Medium',
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM_ITALIC: 'IBMPlexSans-MediumItalic',
  DEFAULT_ANDROID_FONT_FAMILY_SEMIBOLD: 'IBMPlexSans-SemiBold',
  DEFAULT_ANDROID_FONT_FAMILY_SEMIBOLD_ITALIC: 'IBMPlexSans-SemiBoldItalic',
  DEFAULT_ANDROID_FONT_FAMILY_BOLD: 'IBMPlexSans-Bold',
  DEFAULT_ANDROID_FONT_FAMILY_BOLD_ITALIC: 'IBMPlexSans-BoldItalic'
};

export const poppinsFontFamily: IFontFamily = {
  DEFAULT_FONT_FAMILY: 'Poppins',
  DEFAULT_ANDROID_FONT_FAMILY: 'Poppins-Regular',
  DEFAULT_ANDROID_FONT_FAMILY_ITALIC: 'Poppins-Italic',
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM: 'Poppins-Medium',
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM_ITALIC: 'Poppins-MediumItalic',
  DEFAULT_ANDROID_FONT_FAMILY_SEMIBOLD: 'Poppins-SemiBold',
  DEFAULT_ANDROID_FONT_FAMILY_SEMIBOLD_ITALIC: 'Poppins-SemiBoldItalic"',
  DEFAULT_ANDROID_FONT_FAMILY_BOLD: 'Poppins-Bold',
  DEFAULT_ANDROID_FONT_FAMILY_BOLD_ITALIC: '"Poppins-BoldItalic"'
};
